import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fcde24a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col items-center w-full h-full" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full choose-top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-white font-semibold" }, "已选择")
], -1))
const _hoisted_3 = { class: "already-people-list scrollBar w-full h-full flex-1" }
const _hoisted_4 = { class: "peopleName" }
const _hoisted_5 = { class: "flex-1 flex items-center col-text" }
const _hoisted_6 = { class: "w-3/5 employeesCode-ellipsis text-center" }
const _hoisted_7 = { class: "w-2/5 position-ellipsis text-center" }
const _hoisted_8 = { class: "achievements" }
const _hoisted_9 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_checkbox_group, {
        value: _ctx.state.defaultCheckedList,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.defaultCheckedList) = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.plainOptions, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "already-people-item",
              key: index
            }, [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_checkbox, {
                    value: item,
                    onChange: ($event: any) => (_ctx.handelChange(item))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(item.employeesName || item.employeesNmae), 1),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(item.employeesCode ||
                                    item.code), 1),
                        _createElementVNode("div", _hoisted_7, _toDisplayString(item.position), 1)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(item.coefficient && Number(item.coefficient) > 0 ? item.coefficient + '%' : 0 + '%'), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["value", "onChange"])
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value"])
    ])
  ]))
}